export default __webpack_public_path__ + "static/media/yotam-zimri.8e076d98.png";